export const imageCodes = {
    homeBanner: {
        code: "${merchantId}_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F1.%20Banner.jpg?alt=media&token=13d78c19-9b8f-42c6-9f2e-e90c33c4f8df",
    },

    ringImg: {
        code: "${merchantId}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F2.%20Ring.jpg?alt=media&token=b4ecc2b2-52b0-41ca-bce8-d24d4c466995",
    },

    necklaceImg: {
        code: "${merchantId}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F3.%20Necklace.jpg?alt=media&token=61cc3dd8-8d49-4878-84f3-69c57dd1bf76",
    },

    braceletImg: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F4.%20Bracelet.jpg?alt=media&token=a2270438-58d6-4db0-bca0-4202ff79063f",
    },

    earringsImg: {
        code: "${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F5.%20Earring%20Or.jpg?alt=media&token=a5489753-03f3-4c78-a358-806f90e12729",
    },
    
    watchesImg: {
        code: "${merchantId}_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F6.%20Watchs.jpg?alt=media&token=f8e2c6b3-0492-4dc0-9cc9-5e443014c1f1",
    },

    dragonRing: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F7.jpg?alt=media&token=b62673a1-39b1-49f8-a2aa-196e8287eb05",
    },

    dragonText: {
        code: "${merchantId}_tmpl_img_8",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F8.jpg?alt=media&token=4557b9d1-fde5-4717-be48-c5d741dc2128",
    },

    group: {
        code: "${merchantId}_tmpl_img_9",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fgroupphoto.png?alt=media&token=a20fe04f-95ea-4d1e-aa25-789844b59c7e",
    },

    coupleRings: {
        code: "${merchantId}_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F9.%20Couple%20Ring.jpg?alt=media&token=2cfc2dde-1ebe-4afc-aa78-ff16337b9aef",
    },

    animalFigure: {
        code: "${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F10.%20Animal%20Figures.jpg?alt=media&token=5c46ee93-a10c-408e-8fe5-bc3f0b9d5871",
    },

    chain: {
        code: "${merchantId}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F11%20Chain.jpg?alt=media&token=09430e57-5daf-428b-a7a0-dab27a82c846",
    },

    pixiu: {
        code: "${merchantId}_tmpl_img_14",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F12.%20Pixiu%20.jpg?alt=media&token=34d114fb-0589-4578-be6e-8f35044fbebc",
    },

    brandedCollections: {
        code: "${merchantId}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F13.%20Branded%20Collection.jpg?alt=media&token=2ddb2f96-8396-437a-a726-473a69954f36",
    },

    bags: {
        code: "${merchantId}_tmpl_img_16",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F14.Bag.jpg?alt=media&token=8dcb9735-8019-49d5-bc3c-60dd73fb288d",
    },

    goldSet: {
        code: "${merchantId}_tmpl_img_17",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F16%20Gold%20Set.jpg?alt=media&token=5b3216f5-81cc-44c4-a0e8-4bf67f001979",
    },

    diamondSet: {
        code: "${merchantId}_tmpl_img_18",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F17.%20Diamond%20Set%20(a)%201.jpg?alt=media&token=cdc86116-d6f2-4285-ad50-de306f99af99",
    },

    ptSet: {
        code: "${merchantId}_tmpl_img_19",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F18.%20PT%20Set.jpg?alt=media&token=4e6c2a10-91fc-41d3-aaf1-68672f5043e1",
    },

    gemstoneSet: {
        code: "${merchantId}_tmpl_img_20",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F19.%20Gem%20Stone%20Set.jpg?alt=media&token=5f8893f9-4712-4d62-8832-eab8b502fbee",
    },

    category: {
        code: "${merchantId}_tmpl_img_21",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcateg.png?alt=media&token=3c65c441-b97c-4b30-9405-c266f8f9cf7c",
    },

    memberPhoto: {
        code: "${merchantId}_tmpl_img_32",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F29Membership.png?alt=media&token=eb3cd4e4-7c3b-4c81-ab2b-570b4061b1f5",
    },
}


export const titleCodes = {
    categories: {
        code: "${merchantId}_tmpl_title_1",
        title: "Categories"
    },

    featureProducts: {
        code: "${merchantId}_tmpl_title_2",
        title: "Feature Products"
    },

    series: {
        code: "${merchantId}_tmpl_title_3",
        title: "Series"
    },

    memberBigHome: {
        code: "${merchantId}_tmpl_title_8",
        title: "Digital Membership"
    },
}

export const textCodes = {
    rings: {
        code: "${merchantId}_tmpl_text_1",
        text: "Rings"
    },

    necklace: {
        code: "${merchantId}_tmpl_text_2",
        text: "Necklace"
    },

    bracelet: {
        code: "${merchantId}_tmpl_text_3",
        text: "Bracelet"
    },

    earrings: {
        code: "${merchantId}_tmpl_text_4",
        text: "Earrings"
    },

    watches: {
        code: "${merchantId}_tmpl_text_5",
        text: "Watches"
    },

    couple: {
        code: "${merchantId}_tmpl_text_6",
        text: "Couple Rings"
    },

    animal: {
        code: "${merchantId}_tmpl_text_7",
        text: "Animal Figure"
    },

    chainText: {
        code: "${merchantId}_tmpl_text_8",
        text: "Chain"
    },

    pixiuText: {
        code: "${merchantId}_tmpl_text_9",
        text: "Pixiu"
    },

    branded: {
        code: "${merchantId}_tmpl_text_10",
        text: "Branded Collections"
    },

    bagsText: {
        code: "${merchantId}_tmpl_text_11",
        text: "Bags"
    },

    gold: {
        code: "${merchantId}_tmpl_text_12",
        text: "Gold Set"
    },

    diamond: {
        code: "${merchantId}_tmpl_text_13",
        text: "Diamond Set"
    },

    pt: {
        code: "${merchantId}_tmpl_text_14",
        text: "PT Set"
    },

    gem: {
        code: "${merchantId}_tmpl_text_15",
        text: "Gem Stone Set"
    },

    memberLittleHome: {
        code: "${merchantId}_tmpl_text_31",
        text: "Join Our"
    },

    memberDescHome: {
        code: "${merchantId}_tmpl_text_32",
        text: "29 ရတနာ မှာ ​စျေးဝယ်တိုင်း point ​တွေစုပြီး reward ​တွေနဲ့ ပြန်လဲလှယ်လို့ ရ​နေပြီ​နော် ..."
    },

    earnPointsHome: {
        code: "${merchantId}_tmpl_text_49",
        text: "—— Earn Points"
    },
}

export const videoCodes = {
    video1: {
        code: "${merchantId}_tmpl_video_1",
        video: "https://www.youtube.com/embed/ygOL4TCofes"
    },
}